/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ app: NonNullable<unknown>, purpose: NonNullable<unknown> }} Oauth_Email_PurposeInputs */



/**
* | output |
* | --- |
* | "{app} says: {purpose}" |
*
* @param {Oauth_Email_PurposeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const oauth_email_purpose = /** @type {((inputs: Oauth_Email_PurposeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Oauth_Email_PurposeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.app} indique : ${i?.purpose}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.app} indica: ${i?.purpose}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.app} informa: ${i?.purpose}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.app} dichiara: ${i?.purpose}`)
	return /** @type {LocalizedString} */ (`${i?.app} says: ${i?.purpose}`)
});